var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2688,-3348.99)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-27,-128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Delete",
    transform: "matrix(0.390625,-3.79827e-17,-2.67147e-17,0.466492,2457,3274.29)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.56,2.0844e-16,1.64135e-16,2.4,209.92,-1.4966e-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 186,
    width: 36,
    height: 2,
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.56,2.0844e-16,8.20676e-17,1.2,209.92,230.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 192,
    width: 2,
    height: 32,
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.56,2.0844e-16,8.21637e-17,1.2014,209.92,230.093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202,192.031L201,224.031L199,223.969L200,191.969C200.667,191.99 201.333,192.01 202,192.031Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.56,2.0844e-16,8.20676e-17,1.2,209.92,230.363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189,223.969L187,224.031L186,192.031L188,191.969C188.333,202.635 188.666,213.302 189,223.969Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.38933,1.94544e-16,9.84812e-17,1.44,243.029,180.413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.859,226.133C181.879,226.359 181.931,226.579 182.027,226.787C182.255,227.285 182.703,227.684 183.246,227.874C183.454,227.946 183.671,227.985 183.892,227.998C190.609,228.225 197.335,228.076 204.056,227.999C204.278,227.992 204.496,227.958 204.707,227.89C205.271,227.706 205.738,227.3 205.973,226.787C206.069,226.579 206.121,226.359 206.141,226.134L209.003,187.93L211.14,188.07C210.184,200.839 209.391,213.619 208.269,226.376C208.222,226.79 208.119,227.192 207.943,227.575C207.486,228.571 206.593,229.367 205.505,229.747C205.056,229.904 204.586,229.983 204.107,229.999C197.37,230.075 190.63,230.075 183.893,229.999C183.414,229.983 182.944,229.904 182.495,229.747C181.375,229.356 180.463,228.524 180.018,227.488C179.853,227.102 179.759,226.698 179.723,226.285L176.86,188.07L178.997,187.93C179.951,200.665 180.905,213.399 181.859,226.133Z",
    style: {
      fillRule: "nonzero"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.44,4.42936e-16,3.28271e-16,4.8,151.68,367.335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106,15C106,13.895 105.105,14 104,14L100,14C98.895,14 98,13.895 98,15L95,15C94.388,15.001 94.03,15.469 94,16L110,16C110,15.448 109.552,15 109,15L106,15Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.e75a1eab9df8a7b11192ea9b5213f400.svg";
export { ForwardRef as ReactComponent };